import React, { Component, Fragment } from "react";
import _ from "lodash";

//values
import options from "../../../services/common/options";

//components
import Field from "../../Common/Field/Field";

export default class JobWork extends Component {
  render() {
    const { disabled, jobWorkSequence, jobWorkData, fabricInfo } = this.props;
    console.log(jobWorkData, "jobWorkData");
    return (
      <form id="jobwork" name="jobWorkForm">
        <div className="col-md-12 p-0 ">
          <label className="font-weight-bold">Job Work</label>
          {!disabled && (
            <a
              style={{ display: "block" }}
              className="btn-floating btn-small waves-effect waves-light green pull-right"
              onClick={(e) => this.props.addJobWork()}
            >
              <i className="material-icons">add</i>
            </a>
          )}
        </div>
        <div>
          {jobWorkData &&
            jobWorkData.length > 0 &&
            jobWorkData.map((data, i) => {
              console.log(data, "RowData");

              return (
                <div className="col-md-12 nopadding" key={i} id={`jobWrk${i}`}>
                  <div className="card">
                    <div className="col-md-12 nopadding">
                      <div className="col-md-6">
                        <p>Option {i + 1}</p>
                        <select
                          className="select-currency"
                          name="purpose"
                          onChange={(e) =>
                            this.props.updateJobworkDataKeyValue(e, i)
                          }
                          disabled={disabled}
                          value={data.purpose}
                        >
                          <option value="">select</option>
                          {fabricInfo &&
                            fabricInfo.PURPOSE &&
                            fabricInfo.PURPOSE.map((dat, indexOfFabricInfo) => {
                              return (
                                <option
                                  key={indexOfFabricInfo}
                                  value={dat.value}
                                >
                                  {dat.label}
                                </option>
                              );
                            })}
                        </select>
                      </div>
                      <div class="col-md-6">
                        <a
                          style={{ display: "block" }}
                          class="btn-floating btn-small waves-effect waves-light red pull-right my-3 mr-3"
                          id="del-sample-size-btn pull-rog pull-right"
                          onClick={(e) => this.props.removeJobWork(i)}
                        >
                          <i class="material-icons">clear</i>
                        </a>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <table class="table">
                        <thead>
                          <tr className="style-table-border">
                            <th width="10%">Sequence</th>
                            {jobWorkSequence.map((Data, ind) => {
                              return (
                                <th
                                  width={`${90 / jobWorkSequence.length - 1}%`}
                                >
                                  {ind + 1}
                                </th>
                              );
                            })}
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="style-table-border">
                            <td>Process</td>
                            {jobWorkSequence.map((job, ind) => {
                              return (
                                <td>
                                  <select
                                    className="form-control"
                                    onChange={(e) =>
                                      this.props.addingRow(e, i, ind + 1)
                                    }
                                    disabled={disabled}
                                    value={
                                      (data.rowData &&
                                        data.rowData.length &&
                                        !!data.rowData[ind] &&
                                        "key" in data.rowData[ind] &&
                                        data.rowData[ind].key) ||
                                      ""
                                    }
                                  >
                                    <option value="">select</option>
                                    {jobWorkSequence.map((data) => {
                                      return (
                                        <option value={data.key}>
                                          {data.value}
                                        </option>
                                      );
                                    })}
                                  </select>
                                </td>
                              );
                            })}
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="col-md-12">
                      <table class="table">
                        <thead>
                          <tr className="style-table-border">
                            <th scope="col" width="5%">
                              Process
                            </th>
                            <th scope="col" width="11%">
                              Date
                            </th>
                            <th scope="col" width="20%">
                              Supp Name
                            </th>
                            <th scope="col" width="15%">
                              Supp Ref
                            </th>
                            <th scope="col" width="7%">
                              LT(days)
                            </th>
                            <th scope="col" width="7%">
                              Width
                            </th>
                            <th scope="col" width="6%">
                              $/₹
                            </th>
                            <th scope="col" width="11%">
                              Price
                            </th>
                            <th scope="col" width="8%">
                              VL%
                            </th>
                            <th scope="col" width="10%">
                              Cost
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.rowData.map((data, index) =>
                            data.key && data.process !== "" ? (
                              <tr className="style-table-border">
                                <th scope="row">{data.process}</th>
                                <td>
                                  <Field
                                    isFormGroup={false}
                                    inputType="date"
                                    inputName="date"
                                    value={data.date}
                                    index={index}
                                    i={i}
                                    onChange={this.props.updateJobworkRow}
                                    disabled={disabled}
                                  />
                                </td>
                                <td>
                                  <select
                                    className="form-control select-height customized-height-inputform"
                                    name="supplierName"
                                    value={data.supplierName}
                                    disabled={disabled}
                                    onChange={(e) =>
                                      this.props.updateJobworkRow(
                                        e.target.name,
                                        e.target.value,
                                        index,
                                        i,
                                      )
                                    }
                                  >
                                    <option value="">Select</option>
                                    {fabricInfo &&
                                      fabricInfo.SUPPLIERNAME &&
                                      fabricInfo.SUPPLIERNAME.map(
                                        (data, index) => (
                                          <option
                                            key={index}
                                            value={data.value}
                                          >
                                            {data.label}
                                          </option>
                                        ),
                                      )}
                                  </select>
                                </td>
                                <td>
                                  <Field
                                    isFormGroup={false}
                                    inputType="text"
                                    inputName="supplierRef"
                                    value={data.supplierRef}
                                    index={index}
                                    i={i}
                                    onChange={this.props.updateJobworkRow}
                                    disabled={disabled}
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    class="form-control"
                                    name="leadTime"
                                    value={data.leadTime}
                                    disabled={disabled}
                                    onChange={(e) =>
                                      this.props.updateJobworkRow(
                                        e.target.name,
                                        e.target.value,
                                        index,
                                        i,
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    min="0"
                                    class="form-control"
                                    name="width"
                                    value={data.width}
                                    disabled={disabled}
                                    onChange={(e) =>
                                      this.props.updateJobworkRow(
                                        e.target.name,
                                        e.target.value,
                                        index,
                                        i,
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <select
                                    class="select-currency"
                                    name="currency"
                                    value={data.currency}
                                    disabled={disabled}
                                    onChange={(e) =>
                                      this.props.updateJobworkRow(
                                        e.target.name,
                                        e.target.value,
                                        index,
                                        i,
                                      )
                                    }
                                  >
                                    <option value="">---</option>
                                    {options.currency.map((value, index) => (
                                      <option value={value.value} key={index}>
                                        {value.label}
                                      </option>
                                    ))}
                                  </select>
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    min="0"
                                    class="form-control"
                                    name="price"
                                    value={data.price}
                                    disabled={disabled}
                                    onChange={(e) =>
                                      this.props.updateJobworkRow(
                                        e.target.name,
                                        e.target.value,
                                        index,
                                        i,
                                      )
                                    }
                                  />
                                </td>
                                <td>
                                  <input
                                    type="number"
                                    min="0"
                                    class="form-control"
                                    name="vl"
                                    value={data.vl}
                                    disabled={disabled}
                                    onChange={(e) =>
                                      this.props.updateJobworkRow(
                                        e.target.name,
                                        e.target.value,
                                        index,
                                        i,
                                      )
                                    }
                                  />
                                </td>
                                <td>{data.cost ? data.cost : ""}</td>
                              </tr>
                            ) : null,
                          )}
                          <tr>
                            <td
                              colSpan="7"
                              className="text-right border-0 pt-3"
                            >
                              GST
                            </td>
                            <td className="border-0 text-left">
                              {/* <ul className="list-inline nopadding"> */}
                              {/* <li className="nopadding"> */}
                              <input
                                type="text"
                                class="width-30 text-right"
                                name="GST"
                                value={data.GST}
                                disabled={disabled}
                                onChange={(e) => {
                                  (this.props.updateJobworkDataKeyValue(e, i),
                                    setTimeout(
                                      () =>
                                        this.props.updateJobWorkRowDataTotalCost(),
                                      100,
                                    ));
                                }}
                              />
                              <span style={{ marginLeft: "5px" }}>%</span>
                            </td>
                            <td className="border-0">
                              {data.totalCost > 0 &&
                                Number(
                                  Number(data.totalCost) -
                                  Number(data.transport),
                                ).toFixed(2)}
                            </td>
                            <td className="border-0" />
                          </tr>
                          <tr>
                            <td colSpan="7" className="text-right border-0">
                              Transport
                            </td>
                            <td className="border-0 text-left">
                              <input
                                type="text"
                                class="width-30 text-right"
                                name="transport"
                                value={data.transport * 100}
                                disabled={disabled}
                                onChange={(e) => {
                                  (this.props.updateJobworkDataKeyValue(e, i),
                                    setTimeout(
                                      () =>
                                        this.props.updateJobWorkRowDataTotalCost(),
                                      100,
                                    ));
                                }}
                              />
                              <span style={{ marginLeft: "5px" }}>%</span>
                            </td>
                            <td className="border-0">
                              {data.totalCost > 0 && data.totalCost}
                            </td>
                            <td className="border-0" />
                          </tr>
                          <tr>
                            <td colSpan="7" className="border-0">
                              <ul className="list-inline">
                                <Fragment>
                                  <li>
                                    <p className="font-apply-li">MOQ</p>{" "}
                                  </li>
                                </Fragment>
                                <li>
                                  <input
                                    type="text"
                                    class="form-control width-100 d-inline"
                                    value={data.moq}
                                    disabled={disabled}
                                    name="moq"
                                    onChange={(e) =>
                                      this.props.updateJobworkDataKeyValue(e, i)
                                    }
                                  />
                                </li>
                                <li>
                                  <p className="font-apply-li">
                                    Total Lead time
                                  </p>{" "}
                                </li>
                                <li>
                                  <input
                                    type="text"
                                    class="form-control width-100 d-inline"
                                    id="totalleadtime"
                                    value={data.totalLeadTime}
                                    disabled={disabled}
                                    name="totalLeadTime"
                                    onChange={(e) =>
                                      this.props.updateJobworkDataKeyValue(e, i)
                                    }
                                  />
                                </li>
                                <li>
                                  <p className="font-apply-li">
                                    Finished width
                                  </p>
                                </li>
                                <li>
                                  <input
                                    type="text"
                                    class="form-control width-100 d-inline"
                                    id="finishedwidth"
                                    name="finishedWidth"
                                    value={data.finishedWidth}
                                    disabled={disabled}
                                    onChange={(e) =>
                                      this.props.updateJobworkDataKeyValue(e, i)
                                    }
                                  />
                                </li>
                                <li>
                                  <p className="font-apply-li">
                                    Cuttable width
                                  </p>
                                </li>
                                <li>
                                  <input
                                    type="text"
                                    class="form-control width-100 d-inline"
                                    id="cuttablewidth"
                                    name="cuttableWidth"
                                    value={data.cuttableWidth}
                                    disabled={disabled}
                                    onChange={(e) =>
                                      this.props.updateJobworkDataKeyValue(e, i)
                                    }
                                  />
                                </li>
                              </ul>
                            </td>
                            <td className="border-0">
                              <p className="font-apply-li pt-1">Total cost</p>
                            </td>
                            <td className="border-0 thicker">
                              {data.totalCost > 0 && data.totalCost}
                            </td>
                            <td className="border-0">
                              <Field
                                isFormGroup={false}
                                inputType="radio"
                                inputName={`default`}
                                value={"jobwork" + i}
                                checked={data.default}
                                index={i}
                                onChange={(name, value) =>
                                  this.props.updateValueForDefault(
                                    name,
                                    value,
                                    i,
                                    "jobwork",
                                    jobWorkData,
                                  )
                                }
                                disabled={disabled}
                              />
                            </td>
                          </tr>
                          <tr>
                            <td colSpan="7" className="border-0 text-left "
                              style={{ paddingLeft: "2rem" }}>
                              <ul className="list-inline">
                                <li>
                                  <p className="font-apply-li">PL Code</p>
                                </li>
                                <li>
                                  <input
                                    type="text"
                                    className="form-control width-100 d-inline"
                                    name="plCode"
                                    value={data.plCode || ""}
                                    disabled={disabled}
                                    onChange={(e) =>
                                      this.props.updateValue(
                                        e.target.name,
                                        e.target.value,
                                        i,
                                      )
                                    }
                                  />
                                </li>
                                <li>
                                  <p className="font-apply-li">
                                    Material Origin
                                  </p>
                                </li>
                                <li>
                                  <select
                                    className="form-control width-100 d-inline"
                                    name="materialOrigin"
                                    value={data.materialOrigin || ""}
                                    onChange={(e) =>
                                      this.props.updateValue(
                                        e.target.name,
                                        e.target.value,
                                        i,
                                      )
                                    }
                                  >
                                    <option value="">Select</option>
                                    <option value="Local">Local</option>
                                    <option value="Imported">Imported</option>
                                  </select>
                                </li>
                              </ul>
                            </td>
                            <td className="border-0" />
                            <td className="border-0" />
                            <td className="border-0" />
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="col-md-12">
                      <Field
                        isFormGroup={true}
                        inputType={"textarea"}
                        inputName={"specialComments"}
                        value={data.specialComments}
                        index={i}
                        label={"Special Comments"}
                        onChange={this.props.updateValue}
                        disabled={disabled}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </form>
    );
  }
}

JobWork.propTypes = {};

JobWork.defaultProps = {};



// WEBPACK FOOTER //
// ./src/components/SupplierSection/SupplierMain/JobWork.js